<template>
  <div>
    <!-- Hero Section (暗色系科技炫酷风格) -->
    <section class="hero tech-hero">
      <div class="tech-background">
        <div class="grid-lines"></div>
        <div class="particles"></div>
        <div class="glow-effect"></div>
      </div>
      <div class="hero-content">
        <p class="tech-subtitle">爱谱乐医疗以先进的自动化化和信息化技术，提高手术室物资管理水平</p>
        <div class="tech-features">
          <div class="tech-item">
            <div class="tech-number">100+</div>
            <div class="tech-text">医院案例</div>
          </div>
          <div class="tech-item">
            <div class="tech-number">50+</div>
            <div class="tech-text">荣获专利</div>
          </div>
          <div class="tech-item">
            <div class="tech-number">10000m²</div>
            <div class="tech-text">生产面积</div>
          </div>
        </div>
        <div class="tech-buttons">
          <router-link to="/products" class="tech-btn-primary">探索解决方案</router-link>
          <router-link to="/contact" class="tech-btn-outline">联系我们</router-link>
        </div>
      </div>
    </section>

    <!-- 轮播图区域 -->
    <section class="carousel-section">
      <Carousel :images="carouselImages" />
    </section>

    <!-- 方案中心标语 -->
    <section class="solutions-slogan">
      <div class="slogan-background">
        <div class="slogan-grid"></div>
        <div class="slogan-glow"></div>
      </div>
      <div class="slogan-content">
        <h2 class="slogan-title">专注手术室智慧物资管理</h2>
        <p class="slogan-subtitle">竭诚为您服务</p>
      </div>
    </section>

    <!-- 方案中心 -->
    <section class="solutions">
      <div class="container">
        <div class="section-header">
          <h2>方案中心</h2>
          <p>精准 · 智能 · 闭环管理，赋能智慧手术室</p>
        </div>
        <div class="grid-3">
          <div v-for="sol in solutions" :key="sol.title" class="solution-card">
            <div class="card-image">
              <img :src="sol.img" :alt="sol.title">
            </div>
            <h3>{{ sol.title }}</h3>
            <router-link :to="sol.link" class="btn-link">了解详情 →</router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Carousel from '@/components/Carousel.vue';

export default {
  components: { Carousel },
  data() {
    return {
      carouselImages: [
        '/img/1.jpg',
        '/img/2.jpg',
        '/img/3.jpg',
        '/img/4.jpg'
      ],
      solutions: [
        { title: '手术室行为管理系统', img: 'https://picsum.photos/id/48/400/250', link: '/products/behavior' },
        { title: '麻醉药品管理系统', img: 'https://picsum.photos/id/38/400/250', link: '/products/anesthesia' },
        { title: '手术室耗材管理系统', img: 'https://picsum.photos/id/39/400/250', link: '/products/consumables' }
      ]
    };
  }
};
</script>

<style scoped>
/* 暗色系科技炫酷风格 Hero 区域 */
.tech-hero {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8rem 2rem;
  min-height: 600px;
  border-radius: 0;
  margin-top: 0;
  overflow: hidden;
  background: linear-gradient(135deg, #0a0a0f 0%, #1a1a2e 50%, #16213e 100%);
}

.tech-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.grid-lines {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    linear-gradient(rgba(0, 255, 255, 0.1) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 255, 255, 0.1) 1px, transparent 1px);
  background-size: 50px 50px;
  animation: gridMove 20s linear infinite;
}

.particles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.particles::before {
  content: '';
  position: absolute;
  width: 3px;
  height: 3px;
  background: #00ffff;
  border-radius: 50%;
  animation: float 6s ease-in-out infinite;
  filter: blur(1px);
  top: 20%;
  left: 30%;
}

.particles::after {
  content: '';
  position: absolute;
  width: 2px;
  height: 2px;
  background: #00ffff;
  border-radius: 50%;
  animation: float 8s ease-in-out infinite 2s;
  filter: blur(1px);
  top: 60%;
  left: 70%;
}

.glow-effect {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, rgba(0, 255, 255, 0.3) 0%, transparent 70%);
  transform: translate(-50%, -50%);
  animation: pulse 4s ease-in-out infinite;
}

.hero-content {
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 900px;
  color: white;
}

.tech-subtitle {
  font-size: 1.8rem;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 3rem;
  line-height: 1.6;
  text-shadow: 0 0 20px rgba(0, 255, 255, 0.5);
  animation: textGlow 3s ease-in-out infinite alternate;
}

/* 方案中心标语 */
.solutions-slogan {
  position: relative;
  padding: 6rem 2rem;
  min-height: 300px;
  overflow: hidden;
  background: linear-gradient(135deg, #0a0a0f 0%, #1a1a2e 50%, #16213e 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.slogan-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.slogan-grid {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    linear-gradient(rgba(0, 255, 255, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 255, 255, 0.05) 1px, transparent 1px);
  background-size: 40px 40px;
  animation: gridMove 15s linear infinite;
}

.slogan-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 200px;
  height: 200px;
  background: radial-gradient(circle, rgba(0, 255, 255, 0.2) 0%, transparent 70%);
  transform: translate(-50%, -50%);
  animation: pulse 3s ease-in-out infinite;
}

.slogan-content {
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 800px;
}

.slogan-title {
  font-size: 3.5rem;
  font-weight: 700;
  color: #00ffff;
  margin-bottom: 1rem;
  line-height: 1.2;
  text-shadow: 
    0 0 20px rgba(0, 255, 255, 0.6),
    0 0 40px rgba(0, 255, 255, 0.4),
    0 0 60px rgba(0, 255, 255, 0.2);
  animation: sloganGlow 4s ease-in-out infinite alternate;
  background: linear-gradient(135deg, #00ffff, #00bfff, #0080ff);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  position: relative;
}

.slogan-title::before {
  content: '';
  position: absolute;
  top: -10px;
  left: -10px;
  right: -10px;
  bottom: -10px;
  background: linear-gradient(135deg, rgba(0, 255, 255, 0.1), rgba(0, 255, 255, 0.05));
  filter: blur(15px);
  z-index: -1;
  border-radius: 10px;
}

.slogan-subtitle {
  font-size: 1.8rem;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.4;
  text-shadow: 0 0 15px rgba(0, 255, 255, 0.4);
  animation: subtitleFloat 3s ease-in-out infinite alternate;
  letter-spacing: 2px;
}

@keyframes sloganGlow {
  0% {
    text-shadow: 
      0 0 20px rgba(0, 255, 255, 0.6),
      0 0 40px rgba(0, 255, 255, 0.4),
      0 0 60px rgba(0, 255, 255, 0.2);
    transform: scale(1);
  }
  100% {
    text-shadow: 
      0 0 30px rgba(0, 255, 255, 0.8),
      0 0 60px rgba(0, 255, 255, 0.6),
      0 0 90px rgba(0, 255, 255, 0.4);
    transform: scale(1.02);
  }
}

@keyframes subtitleFloat {
  0% {
    transform: translateY(0);
    opacity: 0.8;
  }
  100% {
    transform: translateY(-5px);
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .solutions-slogan {
    padding: 4rem 1rem;
    min-height: 250px;
  }
  
  .slogan-title {
    font-size: 2.5rem;
  }
  
  .slogan-subtitle {
    font-size: 1.4rem;
  }
}

.tech-features {
  display: flex;
  justify-content: center;
  gap: 3rem;
  margin: 3rem 0;
  flex-wrap: wrap;
}

.tech-item {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(20px);
  padding: 2rem 2.5rem;
  border-radius: 15px;
  border: 1px solid rgba(0, 255, 255, 0.2);
  color: white;
  text-align: center;
  min-width: 160px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.tech-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(0, 255, 255, 0.2), transparent);
  transition: left 0.5s ease;
}

.tech-item:hover::before {
  left: 100%;
}

.tech-item:hover {
  transform: translateY(-5px);
  border-color: rgba(0, 255, 255, 0.5);
  box-shadow: 0 15px 40px rgba(0, 255, 255, 0.2);
}

.tech-number {
  font-size: 2.8rem;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 0.8rem;
  background: linear-gradient(135deg, #00ffff, #00bfff);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  text-shadow: 0 0 30px rgba(0, 255, 255, 0.5);
}

.tech-text {
  font-size: 1rem;
  font-weight: 500;
  opacity: 0.8;
  letter-spacing: 1px;
}

.tech-buttons {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex-wrap: wrap;
}

.tech-btn-primary {
  background: linear-gradient(135deg, #00ffff, #00bfff);
  color: #0a0a0f;
  padding: 1rem 2.5rem;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  display: inline-block;
  box-shadow: 0 8px 25px rgba(0, 255, 255, 0.3);
  position: relative;
  overflow: hidden;
}

.tech-btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 35px rgba(0, 255, 255, 0.4);
  color: #0a0a0f;
}

.tech-btn-outline {
  background: transparent;
  border: 2px solid #00ffff;
  color: #00ffff;
  padding: 1rem 2.5rem;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.tech-btn-outline:hover {
  background: rgba(0, 255, 255, 0.1);
  transform: translateY(-3px);
  box-shadow: 0 0 30px rgba(0, 255, 255, 0.3);
}

/* 动画效果 */
@keyframes gridMove {
  0% { transform: translate(0, 0); }
  100% { transform: translate(50px, 50px); }
}

@keyframes float {
  0%, 100% { transform: translateY(0) scale(1); }
  50% { transform: translateY(-20px) scale(1.1); }
}

@keyframes pulse {
  0%, 100% { opacity: 0.3; transform: translate(-50%, -50%) scale(1); }
  50% { opacity: 0.6; transform: translate(-50%, -50%) scale(1.1); }
}

@keyframes textGlow {
  0% { text-shadow: 0 0 20px rgba(0, 255, 255, 0.5); }
  100% { text-shadow: 0 0 30px rgba(0, 255, 255, 0.8), 0 0 40px rgba(0, 255, 255, 0.4); }
}

/* 轮播图区域 */
.carousel-section {
  margin: 3rem 0;
  width: 100vw;
  margin-left: calc(-50vw + 50%);
}

.container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
}

/* 方案中心 */
.solutions {
  padding: 3rem 0;
  background: #ffffff;
}

.section-header {
  text-align: center;
  margin-bottom: 3rem;
}

.section-header h2 {
  font-size: 2.4rem;
  font-weight: 700;
  color: #0f2b36;
  margin-bottom: 0.5rem;
}

.section-header p {
  font-size: 1.1rem;
  color: #5b6e8c;
}

.grid-3 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.solution-card {
  background: white;
  border-radius: 1.5rem;
  overflow: hidden;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  text-align: center;
  padding: 1.5rem;
  border: 1px solid #eef2f6;
}

.solution-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 30px -12px rgba(0, 0, 0, 0.12);
  border-color: #cbd5e1;
}

.card-image {
  width: 100%;
  height: 200px;
  overflow: hidden;
  border-radius: 1rem;
  margin-bottom: 1.5rem;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s;
}

.solution-card:hover .card-image img {
  transform: scale(1.02);
}

.solution-card h3 {
  font-size: 1.4rem;
  margin: 0.8rem 0;
  color: #0f2b36;
}

.btn-link {
  display: inline-block;
  margin-top: 1rem;
  color: #1f8aad;
  text-decoration: none;
  font-weight: 500;
  transition: 0.2s;
}

.btn-link:hover {
  color: #0f5c6e;
  letter-spacing: 0.5px;
}

@media (max-width: 768px) {
  .hero {
    flex-direction: column;
    text-align: center;
    padding: 2rem;
  }
  .hero-content h1 {
    font-size: 2.2rem;
  }
  .hero-buttons {
    justify-content: center;
  }
}
</style>